import { render, staticRenderFns } from "./addCoordinates.vue?vue&type=template&id=331bf6e0&scoped=true&"
import script from "./addCoordinates.vue?vue&type=script&lang=js&"
export * from "./addCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./addCoordinates.vue?vue&type=style&index=0&id=331bf6e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331bf6e0",
  null
  
)

export default component.exports